module.exports = __webpack_public_path__ + "bed-icon.png?3c37bd0876fd6fc0ed8f26faf3841216";